//src/actions/server/users/index.js
//backend



'use server';
import { dbExecute, dbExecuteDB2_ReadOnly, dbExecuteDB1_Write, dbExecuteDB2_Write, dbExecutePanelReadOnly } from '@/../dbConfig.js';

import { getHtml, sendMail, sendMailAsync } from '@/actions/server/mail';
import { resolveRegisterSource } from '@/utils/domainAccess';
import { v4 as uuidv4 } from 'uuid';
import { getAcceptedUserById } from '@/actions/server/crud';
import { encodePassword, generateRandomToken } from '@/actions/server/auth';



export const getLatestLeadsParams = async (userId) => {
  try {
    const query = `
      SELECT id, clickID, params_json
      FROM leads
      WHERE id_user = ?
      ORDER BY created_at DESC
      LIMIT 10
    `;
    const [leads] = await dbExecuteDB2_ReadOnly(query, [userId]);
    return leads.map((lead) => {
      let parsedParams = {};
      try {
        if (lead.params_json && typeof lead.params_json === 'string') {
          parsedParams = JSON.parse(lead.params_json);
        } else if (lead.params_json && typeof lead.params_json === 'object') {
          parsedParams = lead.params_json;
        }
      } catch (parseError) {
        console.error('Error parsing params_json for lead', lead.id, parseError);
      }
      return { id: lead.id, clickID: lead.clickID, ...parsedParams };
    });
  } catch (error) {
    console.error('Error fetching leads params:', error);
    throw new Error('Error fetching leads params: ' + error.message);
  }
};


export const getAdvertiserUsers = async () => {
  try {
    const query = `
      SELECT U.id, U.email, U.first_name, U.last_name
      FROM users U
      JOIN user_role UR ON U.id = UR.id_user
      WHERE UR.id_role = 11
      ORDER BY U.email ASC
    `;
    const [rows] = await dbExecute(query);
    return rows;
  } catch (error) {
    console.error('Error fetching advertisers:', error);
    throw new Error('Error fetching advertisers: ' + error.message);
  }
};

export const getUsers = async () => {
  try {
    const query = `
      SELECT 
        U.id,  
        U.id_user, 
        TL.first_name AS team_leader_first_name, 
        TL.last_name AS team_leader_last_name, 
        TL.email AS team_leader_email,
        U.first_name, 
        U.last_name, 
        U.email, 
        U.is_active, 
        U.description,
        U.register_source,
        R.id AS id_role,
        R.display_name AS role_name, 
        U.created_at, 
        U.updated_at,
        U.is_accepted, U.password,
        U.email_confirmed,
        U.allow_export
      FROM 
        users AS U
      LEFT JOIN 
        users AS TL ON TL.id = U.id_user
      LEFT JOIN 
        user_role AS UR ON U.id = UR.id_user
      LEFT JOIN 
        roles AS R ON UR.id_role = R.id
      ORDER BY U.is_accepted, U.first_name
    `;
    const [users] = await dbExecute(query);

    // Fetch Postback URLs for Partners // It slows down the query, so it's better to fetch it only when needed
    const usersWithDetails = await Promise.all(users.map(async (user) => {
      let postback_url_cpa = '';
      let postback_url_cpl = '';
      // if (user.role_name === 'Partner') {
      //   const postbackSettings = await getPostbackSettingsByUserId(user.id);
      //   postback_url_cpa = postbackSettings?.url_status_change_cpa || '';
      //   postback_url_cpl = postbackSettings?.url_status_change_cpl || '';
      // }
      return {
        ...user,
        team_leader_name: `${user.team_leader_first_name || ''} ${user.team_leader_last_name || ''}`.trim(),
        postback_url_cpa, postback_url_cpl // Add Postback URL to user object
      };
    }));

    return usersWithDetails;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw new Error('Error fetching users: ' + error.message);
  }
};
export const getRoles = async () => {
  try {
    const query = 'SELECT id, display_name FROM roles';
    const [roles] = await dbExecute(query);
    return roles;
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw new Error('Error fetching roles: ' + error.message);
  }
};

export const updateUserStatus = async (id, isActive) => {
  try {
    const query = `UPDATE users SET is_active = ? WHERE id = ?`;
    await dbExecute(query, [isActive, id]);
    return { success: true };
  } catch (error) {
    console.error('Error updating user status:', error);
    throw new Error('Error updating user status: ' + error.message);
  }
};

// Function to fetch a specific user by ID
export const getUserById = async (id) => {
  try {
    const query = `
      SELECT U.id, U.first_name, U.last_name, U.email, U.is_active, U.description, U.register_source, U.commission_usd, U.password, U.id_office,
             UR.id_role, R.display_name AS role_name,
             TL.id AS team_leader_id, TL.first_name AS team_leader_name, 
             TL.email AS team_leader_email, U.confirm_token, 
             U.email_confirmed, U.is_accepted, U.contact_type, U.contact_info,
             U.id_company, U.id_office,
             U.created_at, U.updated_at,
             U.allow_export
      FROM users AS U
      JOIN user_role AS UR ON U.id = UR.id_user
      JOIN roles AS R ON UR.id_role = R.id
      LEFT JOIN users AS TL ON TL.id = U.id_user
      WHERE U.id = ?
    `;
    const [user] = await dbExecute(query, [id]);

    if (user[0]?.id_role === 4) { // If the user is a Partner, fetch postback settings
      const postbackSettings = await getPostbackSettingsByUserId(user[0].id);
      user[0].postback_url_cpa = postbackSettings?.url_status_change_cpa || ''; // Add the postback URL to the user data
      user[0].postback_url_cpl = postbackSettings?.url_status_change_cpl || ''; // Add the postback URL to the user data
    
    
    }

    return user[0];
  } catch (error) {
    console.error('Error fetching user by ID:', error);
    throw new Error('Error fetching user by ID: ' + error.message);
  }
};

// Function to fetch potential team leaders
export const getTeamLeaders = async () => {
  try {
    const query = `
      SELECT U.id, U.first_name, U.last_name
      FROM users AS U
      JOIN user_role AS UR ON U.id = UR.id_user
      JOIN roles AS R ON UR.id_role = R.id
      WHERE UR.id_role = 3 AND is_active=1 ORDER BY U.first_name
    `;
    const [teamLeaders] = await dbExecute(query);
    return teamLeaders;
  } catch (error) {
    console.error('Error fetching team leaders:', error);
    throw new Error('Error fetching team leaders: ' + error.message);
  }
};

const signLabelForRole = (roleId) => {
  const id = String(roleId);
  if (id === '4') return 'Partner';
  if (id === '11') return 'Advertiser';
  return String(roleId);
};

export const addUser = async (userData) => {
  try {
    const sign = signLabelForRole(userData.role);

    // Generate API token
    const randomToken = await generateRandomToken();
    const apiToken = randomToken.password;

    // Encode web password
    const encodedWebPassword = await encodePassword(userData.web_password);

    // Prepare the query and parameters for inserting the user
    const query = `
      INSERT INTO users (first_name, last_name, email, is_active, description, web_password, password, sign, id_user, email_confirmed, is_accepted)
      VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, 1, 1)
    `;

    const params = [
      userData.first_name,
      userData.last_name,
      userData.email,
      userData.isActive ? 1 : 0,
      userData.description,
      encodedWebPassword,
      apiToken,
      sign,
      userData.role === "2" ? userData.team_leader_id : null, // Set id_user (team leader) if role = 2
    ];

    const result = await dbExecute(query, params);
    const userId = result[0].insertId;

    // Prepare the query and parameters for inserting the user
    const query2 = `
      INSERT INTO users (id, first_name, last_name, email, is_active, description, password, sign, id_user, email_confirmed, is_accepted)
      VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, 1, 1)
    `;

    const params2 = [
      userId,
      userData.first_name,
      userData.last_name,
      userData.email,
      userData.isActive ? 1 : 0,
      userData.description,
      apiToken,
      sign,
      userData.role === "2" ? userData.team_leader_id : null, // Set id_user (team leader) if role = 2
    ];

    const result1 = await dbExecuteDB1_Write(query2, params2);
   
    // Insert the role into the user_role table
    const roleQuery = `
      INSERT INTO user_role (id_user, id_role)
      VALUES (?, ?)
    `;
    await dbExecute(roleQuery, [userId, userData.role]);

    return { success: true, userId, apiToken };
  } catch (error) {
    // Check for duplicate email error
    if (error.code === "ER_DUP_ENTRY") {
      if (error.message.includes("users.email")) {
        return { success: false, message: "Email already exists", code: "DUPLICATE_EMAIL" };
      }
      // Check for duplicate password error
      if (error.message.includes("users.password")) {
        return { success: false, message: "Generated API token already in use, please try again", code: "DUPLICATE_PASSWORD" };
      }
    }

    // Handle other errors
    console.error('Error adding user:', error);
    return { success: false, message: "Server error", code: "SERVER_ERROR" };
  }
};

export const updateUser = async (userData, firstAcceptance = false) => {
  try {
    // Never persist roles.display_name ("4. Partner") or raw role id into users.sign
    const sign = signLabelForRole(userData.role);

    // Construct the base update query
    const commissionUsd = Math.max(0, Math.round(Number(userData.commission_usd) || 0));

    let query = `
      UPDATE users
      SET first_name = ?,
          last_name = ?,
          email = ?,
          is_active = ?,
          description = ?,
          sign = ?,
          id_user = ?,
          email_confirmed = ?,
          is_accepted = ?,
          id_company = ?,
          allow_export = ?,
          commission_usd = ?
    `;
    let query2 = `
    UPDATE users
    SET first_name = ?,
        last_name = ?,
        email = ?,
        is_active = ?,
        description = ?,
        sign = ?,
        id_user = ?,
        email_confirmed = ?,
        is_accepted = ?,
        contact_type = ?,
        contact_info = ?,
        id_company = ?,
        allow_export = ?,
        commission_usd = ?
    `;
    // Organize params in the same order as the query fields
    const params = [
      userData.first_name,
      userData.last_name || '', // Handle optional last name
      userData.email,
      userData.isActive ? 1 : 0,
      userData.description,
      sign,
      userData.role === "2" ? userData.team_leader_id : null,
      userData.email_confirmed ? 1 : 0,
      userData.is_accepted ? 1 : 0,
      userData.id_company || null, // Add id_company parameter
      userData.allow_export ? 1 : 0,
      commissionUsd
    ];

    // Organize params in the same order as the query fields
    const params2 = [
      userData.first_name,
      userData.last_name || '', // Handle optional last name
      userData.email,
      userData.isActive ? 1 : 0,
      userData.description,
      sign,
      userData.role === "2" ? userData.team_leader_id : null,
      userData.email_confirmed ? 1 : 0,
      userData.is_accepted ? 1 : 0,
      userData.contact_type,
      userData.contact_info || '', // Handle optional contact info
      userData.id_company || null, // Add id_company parameter
      userData.allow_export ? 1 : 0,
      commissionUsd
    ];

    // Conditionally add the web_password to the update query and parameters
    if (userData.web_password) {
      query2 += `, web_password = ?`;
      const encodedPassword = await encodePassword(userData.web_password);
      params2.push(encodedPassword);
    }

    // Add the WHERE clause and the id parameter
    query += ` WHERE id = ?`;
    query2 += ` WHERE id = ?`;
    params.push(userData.id);
    params2.push(userData.id);

    await dbExecuteDB1_Write(query, params);
    await dbExecute(query2, params2);
    

    // Rest of the code remains the same...
    const roleQuery = `
      UPDATE user_role
      SET id_role = ?
      WHERE id_user = ?
    `;
    await dbExecute(roleQuery, [userData.role, userData.id]);

    if(userData.role === "4" && userData.is_accepted && firstAcceptance) {
      await sendAcceptEmail(userData);
    }

    if (userData.role === "4") {
      await savePostbackSettings(userData.id, userData, userData.first_name);
    }

    if (userData.role === "4" && Array.isArray(userData.customPayouts)) {
      await updateUserProductPayouts(userData.id, userData.customPayouts);
    }

    if (userData.role === "11") {
      const { syncAdvertiserProductDefaultPayouts } = await import(
        '@/actions/server/products'
      );
      await syncAdvertiserProductDefaultPayouts(userData.id, commissionUsd);
    }

    return { success: true };
  } catch (error) {
    console.error('Error updating user:', error);
    throw new Error(`Error updating user: ${error.message}`);
  }
};


// Function to get postback settings for a user
export const getPostbackSettingsByUserId = async (userId) => {
  try {
    const query = `SELECT * FROM postback_settings WHERE id_user = ?`;
    const [settings] = await dbExecuteDB2_Write(query, [userId]);
    return settings[0]; // Return the settings for the given user
  } catch (error) {
    console.error('Error fetching postback settings:', error);
    throw new Error('Error fetching postback settings: ' + error.message);
  }
};

// Function to insert or update postback settings
export const savePostbackSettings = async (userId, userData, partnerName) => {
  try {
    // Extract all postback URL fields from userData
    const postbackFields = {};
    
    // Get all keys from userData that start with 'url_' and end with '_cpa' or '_cpl'
    Object.keys(userData).forEach(key => {
      if (key.startsWith('url_') && (key.endsWith('_cpa') || key.endsWith('_cpl'))) {
        postbackFields[key] = userData[key];
      }
    });
    
    // Build dynamic query based on available fields
    const fields = Object.keys(postbackFields);
    
    if (fields.length === 0) {
      return { success: true }; // No fields to update
    }
    
    const insertFields = ['id_user', ...fields, 'partner_name'].join(', ');
    const placeholders = Array(fields.length + 2).fill('?').join(', ');
    const updateClauses = fields.map(field => `${field} = VALUES(${field})`).join(', ');
    
    const query = `
      INSERT INTO postback_settings (${insertFields})
      VALUES (${placeholders})
      ON DUPLICATE KEY UPDATE 
      ${updateClauses},
      partner_name = VALUES(partner_name)
    `;
    
    // Prepare parameters in the same order as fields
    const params = [userId, ...fields.map(field => postbackFields[field]), partnerName];
    
    await dbExecuteDB2_Write(query, params);
    return { success: true };
  } catch (error) {
    console.error('Error saving postback settings:', error);
    throw new Error('Error saving postback settings: ' + error.message);
  }
};




// Function to update user-specific payouts
// Function to update user-specific payouts


// Function to get all the users with their respective roles

export const getUserByEmail = async (email) => {
  try {
    const query = 'SELECT * FROM users WHERE email = ?';
    const [user] = await dbExecute(query, [email]);
    return user[0];
  } catch (error) {
    console.error('Error fetching user by email:', error);
    throw new Error('Error fetching user by email: ' + error.message);
  }
};

const isLeadScaleMailHost = (hostname) => {
  const host = String(hostname || '')
    .split(':')[0]
    .toLowerCase();
  return host === 'app.leadscaleglobal.com' || host === 'advertiser.exodopanel.com';
};

/** Confirm / reset links for LeadScale always use app.leadscaleglobal.com (not advertiser / localhost). */
const getLeadScaleAppOrigin = () => {
  const isDev = process.env.NEXT_PUBLIC_APP_ENV === 'development';
  return isDev ? 'http://app.leadscaleglobal.com:3000' : 'https://app.leadscaleglobal.com';
};

const getMailAssetHost = () =>
  process.env.NEXT_PUBLIC_MAILINK_HOST ||
  process.env.NEXT_PUBLIC_APP_URL ||
  'https://exodopanel.com';

// Function to send confirmation email
export const sendConfirmationEmail = async ({ email, confirm_token, linkHost } = {}) => {
  const envHost =
    process.env.NEXT_PUBLIC_APP_ENV == 'development'
      ? process.env.NEXT_PUBLIC_APP_HOST
      : process.env.NEXT_PUBLIC_MAILINK_HOST;
  const cleanLinkHost = String(linkHost || '')
    .split(':')[0]
    .toLowerCase();
  const leadScale = isLeadScaleMailHost(cleanLinkHost);
  const host = leadScale ? getLeadScaleAppOrigin() : envHost;
  const confirmationLink = `${host}/register/confirm?email=${encodeURIComponent(email)}&token=${confirm_token}`;
  const templateHost = getMailAssetHost();
  const html = await getHtml(
    leadScale ? 'confirmationEmailLeadscale' : 'confirmationEmail',
    {
      templateHost,
      logoUrl: leadScale
        ? `${templateHost}/logo-leadscale.png`
        : `${templateHost}/logo-affland.png`,
      confirmationLink,
    }
  );

  // Use background email sending to avoid blocking registration
  try {
    return await sendMailAsync({
      to: email,
      subject: leadScale
        ? 'Thank You for Registering — Confirm your LeadScale email'
        : 'Thank You for Your Registration Request',
      html
    });
  } catch(eMailing) {
    console.log('mailing failed !', eMailing);
    return { error: 'Email failed but registration succeeded' };
  }
};

export const sendNotifEmail = async (
  subject,
  {
    id,
    email,
    contact_type,
    contact_info,
    register_source,
    registerHost,
    roleId,
    roleLabel,
  } = {}
) => {
  const host = process.env.NEXT_PUBLIC_APP_ENV == 'development' ? process.env.NEXT_PUBLIC_APP_HOST : process.env.NEXT_PUBLIC_MAILINK_HOST;
  const userLink = `${host}/panel/lms/users/edit/${id}`;

  const sourceRaw = String(register_source || '').toLowerCase();
  const registerSourceLabel =
    sourceRaw === 'leadscale'
      ? 'LeadScale'
      : sourceRaw === 'affland'
        ? 'Affland'
        : sourceRaw === 'exodo'
          ? 'Exodo'
          : sourceRaw || 'Unknown';
  const resolvedRoleLabel =
    roleLabel ||
    (Number(roleId) === 11 ? 'Advertiser' : Number(roleId) === 4 ? 'Partner / Affiliate' : '—');
  const resolvedHost = registerHost || '—';

  // Inbox-friendly subject for registration approvals
  const mailSubject =
    subject && String(subject).includes('New User Registration')
      ? `${subject} [${registerSourceLabel}]`
      : subject;

  const html = await getHtml('notifEmail', {
    templateHost: process.env.NEXT_PUBLIC_MAILINK_HOST,
    subject: mailSubject,
    id,
    email,
    contact_type: contact_type || '—',
    contact_info: contact_info || '—',
    userLink,
    registerSourceLabel,
    roleLabel: resolvedRoleLabel,
    registerHost: resolvedHost,
  });

  // Use background email sending to avoid blocking registration
  try {
    return await sendMailAsync({
      to: ['bussiness.development@exodo.id', 'exodopanel+notification@gmail.com'],
      subject: mailSubject,
      html
    });
  } catch(eMailing) {
    console.log('mailing failed !', eMailing);
    return { error: 'Email failed but registration succeeded' };
  }
};

export const sendAcceptEmail = async ({ id, email }) => {
  const host = process.env.NEXT_PUBLIC_APP_ENV == 'development' ? process.env.NEXT_PUBLIC_APP_HOST : process.env.NEXT_PUBLIC_MAILINK_HOST;
  
  const user = await getAcceptedUserById(id);

  const html = await getHtml('acceptEmail', {
    templateHost: process.env.NEXT_PUBLIC_MAILINK_HOST,
    host,
    ...user
  });

  try {
    // Send to the user
    await sendMail({
      to: email,
      subject: 'Welcome to Our Affiliate Program!',
      html
    });

    // Send copy to exodopanel@gmail.com
    await sendMail({
      to: 'exodopanel@gmail.com',
      subject: `Copy: Affiliate Program Acceptance - ${email}`,
      html
    });
  } catch(eMailing) {
    console.log('mailing failed !', eMailing);
  }
};

// Registration function
export const registerUser = async (userData) => {
  try {
    const existingUser = await getUserByEmail(userData.email);
    if (existingUser) {
      return { 
        success: false, 
        message: 'This email address is already registered. Please use a different email or try logging in.' 
      };
    }

    const web_password = await encodePassword(userData.password);
    const randomToken = await generateRandomToken();
    const token = randomToken.password;

    const confirm_token = uuidv4();
    const roleId = Number(userData.roleId) === 11 ? 11 : 4;
    const signLabel = roleId === 11 ? 'Advertiser' : 'Partner';
    const registerHost = String(userData.registerHost || '')
      .split(':')[0]
      .toLowerCase();
    const descriptionHost =
      registerHost === 'app.leadscaleglobal.com' || registerHost === 'advertiser.exodopanel.com'
        ? registerHost
        : roleId === 11
          ? 'advertiser.exodopanel.com'
          : userData.registerSource === 'leadscale'
            ? 'app.leadscaleglobal.com'
            : 'affland.id';
    const register_source =
      userData.registerSource === 'leadscale' ||
      userData.registerSource === 'affland' ||
      userData.registerSource === 'exodo'
        ? userData.registerSource
        : descriptionHost.includes('leadscale') || descriptionHost.includes('advertiser.exodopanel')
          ? 'leadscale'
          : descriptionHost.includes('affland')
            ? 'affland'
            : resolveRegisterSource(registerHost, roleId);
    const query1 = `
      INSERT INTO users (email, web_password, password, sign, confirm_token, contact_type, contact_info, description, register_source, is_active, email_confirmed, is_accepted)
      VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, 1, 0, 0)
    `;
    const params1 = [
      userData.email, 
      web_password, 
      token, 
      signLabel,
      confirm_token, 
      userData.contact_type, 
      userData.contact_info != '' ? userData.contact_info : null,
      descriptionHost,
      register_source,
    ];
    const result1 = await dbExecute(query1, params1);
    const userId1 = result1[0].insertId;

    const query2 = `
      INSERT INTO users (id, email, password, sign, description, is_active)
      VALUES (?, ?, ?, ?, ?, ?)
    `;
    const params2 = [userId1, userData.email, token, roleId, descriptionHost, 1];
    await dbExecuteDB1_Write(query2, params2);

    const roleQuery = `INSERT INTO user_role (id_user, id_role) VALUES (?, ?)`;
    await dbExecute(roleQuery, [userId1, roleId]);

    return { success: true, confirm_token, userId1, ...userData };
  } catch (error) {
    console.error('Error registering user:', error);
    
    // Handle specific database errors
    if (error.code === 'ER_DUP_ENTRY') {
      if (error.message.includes('users.email')) {
        return { 
          success: false, 
          message: 'This email address is already registered. Please use a different email or try logging in.' 
        };
      }
      if (error.message.includes('users.password')) {
        return { 
          success: false, 
          message: 'Registration failed due to a system conflict. Please try again.' 
        };
      }
    }
    
    return { 
      success: false, 
      message: 'Registration failed. Please try again later or contact support if the problem persists.' 
    };
  }
};

export const confirmTokenValidation = async (email, token) => {
  try {
    const query = `
      SELECT id, email, contact_type, contact_info FROM users
      WHERE email = ? 
      AND confirm_token = ?
    `;
    const [ [ dbResult ] ] = await dbExecute(query, [email, token]);

    if(!dbResult) {
      throw new Error('Wrong confirm token');
    }

    return dbResult;

  } catch (error) {
    console.error('Error confirming token:', error);
    throw new Error('Wrong confirm token');
  }
};

// Confirm email function
export const confirmUserEmail = async (email) => {
  try {
    const query = `
      UPDATE users
      SET email_confirmed = 1
      WHERE email = ?
    `;
    await dbExecute(query, [email]);
    await dbExecuteDB1_Write(query, [email]);
    
  } catch (error) {
    console.error('Error confirming email:', error);
    throw new Error('Error confirming email');
  }
};

export const answerSurvey = async (id_user, question, answer) => {
  try {
    const query = `
      INSERT INTO user_survey_answers (id_user, question, answer)
      VALUES (?, ?, ?)
    `;
    await dbExecute(query, [id_user, question, answer]);

  } catch (error) {
    console.error('Error updating survey answer payouts:', error);
    throw new Error('Error updating survey answer payouts: ' + error.message);
  }
};







export const getProductsForPayout = async () => {
  try {
    const query = `
      SELECT 
        id, 
        name, 
        default_payout_usd, 
        default_type,
        is_visible_for_partners
      FROM products where is_active = 1
      ORDER BY name ASC
    `;
    const [products] = await dbExecute(query);
    return products;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw new Error('Error fetching products: ' + error.message);
  }
};

// In your server actions (users.js), add:
export const getUserSurveyAnswers = async (userId) => {
  try {
    const query = `
      SELECT question, answer, created_at
      FROM user_survey_answers
      WHERE id_user = ?
      ORDER BY created_at DESC
    `;
    const [answers] = await dbExecute(query, [userId]);
    return answers;
  } catch (error) {
    console.error('Error fetching survey answers:', error);
    throw new Error('Error fetching survey answers: ' + error.message);
  }
};
export const getUserProductPayouts = async (userId) => {
  try {
    const query = `
      SELECT 
        p.id AS id_product, 
        p.name, 
        p.default_payout_usd,
        p.is_visible_for_partners,
        upp.payout_usd/100 AS user_payout_usd,
        upp.payout_type AS user_payout_type,
        upp.ga,
        upp.is_exclusive,
        upp.created_at,
        upp.updated_at
      FROM products p 
      LEFT JOIN user_product_payouts upp ON upp.id_product = p.id AND upp.id_user = ?
      WHERE p.is_active = 1
      ORDER BY p.name
    `;
    const [products] = await dbExecuteDB2_Write(query, [userId]);
    return products;
  } catch (error) {
    console.error('Error fetching user-specific payouts:', error);
    throw new Error('Error fetching user-specific payouts: ' + error.message);
  }
};

export const getAllGaPayouts = async () => {
  try {
    const [uppRows] = await dbExecuteDB2_ReadOnly(`
      SELECT p.id AS id_product, p.name AS product_name, upp.id_user,
        upp.payout_usd/100 AS user_payout_usd, upp.payout_type AS user_payout_type,
        upp.ga, upp.created_at, upp.updated_at
      FROM user_product_payouts upp
      JOIN products p ON p.id = upp.id_product
      WHERE upp.ga > 0
    `);

    const [settingsRows] = await dbExecuteDB2_ReadOnly(`
      SELECT DISTINCT psp.id_user, psp.id_product
      FROM payout_settings_plan psp
      JOIN products p ON p.id = psp.id_product
      WHERE psp.ga > 0
      AND (psp.end_at IS NULL OR psp.end_at > NOW())
    `);

    const [pubIdRows] = await dbExecuteDB2_ReadOnly(`
      SELECT DISTINCT ppbp.id_user, ppbp.id_product
      FROM plan_payout_by_pub_id ppbp
      JOIN products p ON p.id = ppbp.id_product
      WHERE ppbp.ga > 0
      AND (ppbp.end_at IS NULL OR ppbp.end_at > NOW())
    `);

    const pairSet = new Set();
    (uppRows || []).forEach((r) => pairSet.add(`${r.id_user}-${r.id_product}`));
    (settingsRows || []).forEach((r) => pairSet.add(`${r.id_user}-${r.id_product}`));
    (pubIdRows || []).forEach((r) => pairSet.add(`${r.id_user}-${r.id_product}`));

    const pairs = [...pairSet];
    if (pairs.length === 0) return [];

    const pairTuples = pairs.map((p) => p.split('-').map(Number));
    const inClause = pairTuples.map(() => '(?,?)').join(',');
    const inParams = pairTuples.flat();

    const uppByKey = new Map((uppRows || []).map((r) => [`${r.id_user}-${r.id_product}`, r]));

    const [userRows] = await dbExecutePanelReadOnly(
      `SELECT id, first_name FROM users WHERE id IN (${[...new Set(pairTuples.map((t) => t[0]))].map(() => '?').join(',')})`,
      [...new Set(pairTuples.map((t) => t[0]))]
    );
    const userMap = new Map(
      (userRows || []).map((u) => {
        const name = String(u.first_name ?? u.first_Name ?? '').trim();
        return [u.id, name || `User ${u.id}`];
      })
    );

    const [productsRows] = await dbExecuteDB2_ReadOnly(
      `SELECT id, name FROM products WHERE id IN (${[...new Set(pairTuples.map((t) => t[1]))].map(() => '?').join(',')})`,
      [...new Set(pairTuples.map((t) => t[1]))]
    );
    const productMap = new Map((productsRows || []).map((p) => [p.id, p.name]));

    const settingsQuery = `
      SELECT id, id_user, id_product, payout_usd/100 AS payout_usd, payout_type, ga, start_from, end_at
      FROM payout_settings_plan WHERE (id_user, id_product) IN (${inClause})
      AND (end_at IS NULL OR end_at > NOW()) ORDER BY start_from ASC
    `;
    const pubIdQuery = `
      SELECT id, id_user, id_product, pub_id, payout_usd/100 AS payout_usd, payout_scheme, ga, start_from, end_at
      FROM plan_payout_by_pub_id WHERE (id_user, id_product) IN (${inClause})
      AND (end_at IS NULL OR end_at > NOW()) ORDER BY start_from ASC, pub_id ASC
    `;

    const [[settingsPlans], [pubIdPlans]] = await Promise.all([
      dbExecuteDB2_ReadOnly(settingsQuery, inParams),
      dbExecuteDB2_ReadOnly(pubIdQuery, inParams),
    ]);

    const settingsByKey = new Map();
    (settingsPlans || []).forEach((p) => {
      const k = `${p.id_user}-${p.id_product}`;
      if (!settingsByKey.has(k)) settingsByKey.set(k, []);
      settingsByKey.get(k).push(p);
    });
    const pubIdByKey = new Map();
    (pubIdPlans || []).forEach((p) => {
      const k = `${p.id_user}-${p.id_product}`;
      if (!pubIdByKey.has(k)) pubIdByKey.set(k, []);
      pubIdByKey.get(k).push(p);
    });

    return pairs.map((key) => {
      const [id_user, id_product] = key.split('-').map(Number);
      const upp = uppByKey.get(key);
      const firstSettings = settingsByKey.get(key)?.[0];
      const firstPubId = pubIdByKey.get(key)?.[0];
      return {
        id_user,
        id_product,
        product_name: productMap.get(id_product) || upp?.product_name || '-',
        partner_name: userMap.get(id_user) || `User ${id_user}`,
        user_payout_usd: upp?.user_payout_usd,
        user_payout_type: upp?.user_payout_type,
        ga: upp?.ga ?? firstSettings?.ga ?? firstPubId?.ga,
        created_at: upp?.created_at ?? firstSettings?.start_from ?? firstPubId?.start_from,
        updated_at: upp?.updated_at,
        settingsPlans: settingsByKey.get(key) || [],
        pubIdPlans: pubIdByKey.get(key) || [],
      };
    });
  } catch (error) {
    console.error('Error fetching all GA payouts:', error);
    throw new Error('Error fetching all GA payouts: ' + error.message);
  }
};

export const updateUserProductPayouts = async (userId, customPayouts) => {
  try {
    // First, delete existing payouts for this user
    const deleteQuery = `
      DELETE FROM user_product_payouts 
      WHERE id_user = ?
    `;
    await dbExecuteDB2_Write(deleteQuery, [userId]);

    // Then insert new payouts if there are any
    if (customPayouts && customPayouts.length > 0) {
      const validPayouts = customPayouts.filter(payout => 
        payout.user_payout_usd !== null || payout.is_exclusive
      );

      if (validPayouts.length > 0) {
        const insertQuery = `
          INSERT INTO user_product_payouts 
          (id_user, id_product, payout_usd, payout_type, is_exclusive, ga) 
          VALUES (?, ?, ?, ?, ?, ?)
        `;

        // Execute insert for each valid payout
        for (const payout of validPayouts) {
          await dbExecuteDB2_Write(insertQuery, [
            userId,
            payout.id_product,
            payout.user_payout_usd ? payout.user_payout_usd * 100 : 0,
            payout.user_payout_type || 'CPA',
            payout.is_exclusive ? 1 : 0,
            payout.ga !== null && payout.ga !== undefined ? payout.ga : 0
          ]);
        }
      }
    }

    return true;
  } catch (error) {
    console.error('Error updating user product payouts:', error);
    throw new Error('Error updating user product payouts: ' + error.message);
  }
};

// Update the getProducts function for Available offers page
export const getProducts = async (userId) => {
  try {
    const query = `
      SELECT 
        p.*,
        upp.payout_usd/100 AS user_payout_usd,
        upp.payout_type AS user_payout_type,
        upp.is_exclusive
      FROM products p
      LEFT JOIN user_product_payouts upp ON p.id = upp.id_product AND upp.id_user = ?
      WHERE 
        p.is_visible_for_partners = 1 
        OR (p.is_visible_for_partners = 0 AND upp.is_exclusive = 1)
      ORDER BY p.name ASC
    `;

    const [products] = await dbExecuteDB2_ReadOnly(query, [userId]);
    return products;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw new Error('Error fetching products: ' + error.message);
  }
};

// PLAN PAYOUT
// Add to src/actions/server/users/index.js


// src/actions/server/users/index.js


export const processPayoutPlans = async () => {
  try {
    // Get all payout plans that should be activated
    const getPlansQuery = `
      SELECT 
        p.id,
        p.id_user,
        p.id_product,
        p.payout_usd,
        p.payout_type,
        p.is_exclusive,
        p.start_from
      FROM payout_settings_plan p
      WHERE 
        p.start_from <= NOW()
        AND p.end_at IS NULL
        AND NOT EXISTS (
          SELECT 1 
          FROM user_product_payouts upp 
          WHERE upp.id_user = p.id_user 
          AND upp.id_product = p.id_product 
          AND upp.created_at >= p.start_from
        )
    `;

    const [plansToProcess] = await dbExecuteDB2_Write(getPlansQuery);

    // Process each plan
    const processPromises = plansToProcess.map(async (plan) => {
      // Update or insert into user_product_payouts
      const upsertQuery = `
        INSERT INTO user_product_payouts 
        (id_user, id_product, payout_usd, payout_type, is_exclusive, created_at)
        VALUES (?, ?, ?, ?, ?, ?)
        ON DUPLICATE KEY UPDATE
        payout_usd = VALUES(payout_usd),
        payout_type = VALUES(payout_type),
        is_exclusive = VALUES(is_exclusive),
        updated_at = NOW()
      `;

      await dbExecuteDB2_Write(upsertQuery, [
        plan.id_user,
        plan.id_product,
        plan.payout_usd,
        plan.payout_type,
        plan.is_exclusive,
        plan.start_from
      ]);

      // Mark the plan as processed
      const updatePlanQuery = `
        UPDATE payout_settings_plan 
        SET end_at = NOW() 
        WHERE id = ?
      `;
      return dbExecuteDB2_Write(updatePlanQuery, [plan.id]);
    });

    await Promise.all(processPromises);

    return {
      success: true,
      processed: plansToProcess.length,
      message: `Successfully processed ${plansToProcess.length} payout plans`
    };
  } catch (error) {
    console.error('Error processing payout plans:', error);
    throw new Error('Error processing payout plans: ' + error.message);
  }
};

// Add this helper function to handle multiple statement queries if needed
export const executeMultipleQueries = async (queries) => {
  for (const query of queries) {
    await dbExecuteDB2_Write(query.sql, query.params || []);
  }
};

// Update the getPayoutPlans function to include more details
export const getPayoutPlans = async (userId) => {
  try {
    const query = `
      SELECT 
        psp.id,
        psp.id_product,
        psp.payout_usd/100 as user_payout_usd,
        psp.payout_type as user_payout_type,
        DATE_FORMAT(CONVERT_TZ(psp.start_from, @@session.time_zone, '+00:00'), '%Y-%m-%d %H:%i:%s') as start_from,
        psp.end_at,
        psp.is_exclusive,
        psp.ga,
        p.name as product_name,
        p.default_payout_usd/100 as default_payout_usd
      FROM payout_settings_plan psp
      JOIN products p ON p.id = psp.id_product
      WHERE psp.id_user = ?
      AND (psp.end_at IS NULL OR psp.end_at > NOW())
      ORDER BY psp.start_from ASC, p.name ASC
    `;
    const [plans] = await dbExecuteDB2_Write(query, [userId]);
    return plans;
  } catch (error) {
    console.error('Error fetching payout plans:', error);
    throw new Error('Error fetching payout plans: ' + error.message);
  }
};


export const savePayoutPlan = async (userId, payoutPlanData, start_from) => {
  try {
    // First get any existing plans that would overlap with the new plans
    const getExistingPlansQuery = `
      SELECT id, id_product, start_from, end_at
      FROM payout_settings_plan 
      WHERE id_user = ? 
      AND id_product IN (?)
      AND (
        end_at IS NULL 
        OR end_at > ?
      )
      ORDER BY start_from ASC
    `;

    // Filter valid plans first
    const validPlans = payoutPlanData.filter(plan => 
      plan && 
      plan.id_product && 
      plan.user_payout_usd !== undefined && 
      plan.user_payout_usd !== null && 
      plan.user_payout_usd !== '' && 
      plan.user_payout_type
    );

    if (validPlans.length === 0) {
      //return true; // No valid plans to save
      throw new Error('Please set up USD value  and TYPE VALUE: ');
    }

    // Get list of product IDs from valid plans
    const productIds = validPlans.map(plan => plan.id_product);
    
    // Get existing plans for these products
    const [existingPlans] = await dbExecuteDB2_Write(getExistingPlansQuery, [
      userId, 
      productIds,
      start_from
    ]);

    // Update end_at for overlapping plans
    for (const existing of existingPlans) {
      const updateEndAtQuery = `
        UPDATE payout_settings_plan 
        SET end_at = ? 
        WHERE id = ?
      `;
      await dbExecuteDB2_Write(updateEndAtQuery, [
        start_from,
        existing.id
      ]);
    }

    // Insert new plans
    const insertQuery = `
      INSERT INTO payout_settings_plan 
        (id_user, id_product, payout_usd, payout_type, is_exclusive, ga, start_from) 
      VALUES 
        (?, ?, ?, ?, ?, ?, ?)
    `;

    for (const plan of validPlans) {
      await dbExecuteDB2_Write(insertQuery, [
        userId,
        plan.id_product,
        plan.user_payout_usd * 100,
        plan.user_payout_type,
        plan.is_exclusive ? 1 : 0,
        plan.ga !== null && plan.ga !== undefined ? plan.ga : 0,
        start_from
      ]);
    }

    return true;
  } catch (error) {
    console.error('Error saving payout plan:', error);
    throw new Error('Error saving payout plan: ' + error.message);
  }
};


// Add to src/actions/server/users/index.js

export const deletePayoutPlan = async (planId, userId) => {
  try {
    const verifyQuery = `
      SELECT id FROM payout_settings_plan
      WHERE id = ? AND id_user = ? AND start_from > NOW()
    `;
    const [verifyResult] = await dbExecuteDB2_Write(verifyQuery, [planId, userId]);
    if (verifyResult.length === 0) {
      throw new Error('Plan not found or cannot be deleted (only future plans)');
    }
    await dbExecuteDB2_Write(
      `DELETE FROM payout_settings_plan WHERE id = ? AND id_user = ? AND start_from > NOW()`,
      [planId, userId]
    );
    return { success: true };
  } catch (error) {
    console.error('Error deleting payout plan:', error);
    throw new Error('Error deleting payout plan: ' + error.message);
  }
};

export const deletePlanPayoutByPubId = async (planId, userId) => {
  try {
    const verifyQuery = `
      SELECT id FROM plan_payout_by_pub_id
      WHERE id = ? AND id_user = ? AND start_from > NOW()
    `;
    const [verifyResult] = await dbExecuteDB2_Write(verifyQuery, [planId, userId]);
    if (verifyResult.length === 0) {
      throw new Error('Plan not found or cannot be deleted (only future plans)');
    }
    await dbExecuteDB2_Write(
      `DELETE FROM plan_payout_by_pub_id WHERE id = ? AND id_user = ? AND start_from > NOW()`,
      [planId, userId]
    );
    return { success: true };
  } catch (error) {
    console.error('Error deleting plan_payout_by_pub_id:', error);
    throw new Error('Error deleting plan: ' + error.message);
  }
};



// In src/actions/server/users/index.js

export const getPayoutHistory = async (userId) => {
  try {
    const query = `
      WITH changes AS (
        SELECT 
          l.payout_scheme,
          l.id_product,
          p.name as product_name,
          l.payout_usd,
          l.created_at,
          LAG(l.payout_usd) OVER (
            PARTITION BY l.id_product 
            ORDER BY l.created_at
          ) AS prev_payout
        FROM leads l
        JOIN products p ON p.id = l.id_product
        WHERE l.id_user = ?
        GROUP BY 
          l.payout_scheme,
          l.id_product,
          p.name,
          l.payout_usd,
          l.created_at
      )
      SELECT 
        c.payout_scheme,
        c.payout_usd/100 as amount,
        c.product_name,
        c.id_product,
        c.created_at as changed_at,
        c.prev_payout/100 as previous_amount
      FROM changes c
      WHERE c.payout_usd != COALESCE(c.prev_payout, -1)
      ORDER BY c.product_name ASC, c.created_at DESC
    `;

    const [history] = await dbExecuteDB2_ReadOnly(query, [userId]);
    return history;
  } catch (error) {
    console.error('Error fetching payout history:', error);
    throw new Error('Error fetching payout history: ' + error.message);
  }
};



// In src/actions/server/users/index.js

export const getPayoutsByPublishId = async (userId) => {
  try {
    // Get current settings from payout_by_pub_id table
    const currentSettingsQuery = `
      SELECT 
        pbp.id,
        pbp.id_product,
        p.name as product_name,
        pbp.payout_usd/100 as payout_usd,
        pbp.payout_scheme,
        pbp.pub_id,
        pbp.ga
      FROM payout_by_pub_id pbp
      JOIN products p ON p.id = pbp.id_product
      WHERE pbp.id_user = ?
      ORDER BY p.name ASC, pbp.pub_id ASC, pbp.payout_scheme ASC
    `;

    // Get all unique publishIDs from leads
    const uniquePubIdsQuery = `
      SELECT DISTINCT 
        l.publishID,
        l.id_product,
        p.name as product_name,
        l.payout_scheme,
        l.payout_usd/100 as existing_payout_usd
      FROM leads l
      JOIN products p ON p.id = l.id_product
      WHERE l.id_user = ? 
      AND l.publishID IS NOT NULL
      GROUP BY l.publishID, l.id_product, p.name, l.payout_scheme, l.payout_usd
      ORDER BY p.name ASC, l.publishID ASC, l.payout_scheme ASC
    `;

    const [savedSettings] = await dbExecuteDB2_Write(currentSettingsQuery, [userId]);
    const [activeLeads] = await dbExecuteDB2_ReadOnly(uniquePubIdsQuery, [userId]);

    return {
      savedSettings: savedSettings,
      activeLeads: activeLeads
    };
  } catch (error) {
    console.error('Error fetching publishID payouts:', error);
    throw new Error('Error fetching publishID payouts: ' + error.message);
  }
};

export const savePayoutByPublishId = async (userId, payoutData) => {
  try {
    // Handle inserts and updates
    for (const payout of payoutData) {
      // Skip if all essential fields are empty/null
      const hasValues = payout.payout_usd || payout.ga || payout.payout_scheme;
      if (!hasValues) continue;

      if (payout.id) {
        // Update existing record
        const updateQuery = `
          UPDATE payout_by_pub_id 
          SET 
            payout_usd = ?,
            payout_scheme = ?,
            ga = ?
          WHERE id = ? AND id_user = ?
        `;
        
        await dbExecuteDB2_Write(updateQuery, [
          payout.payout_usd ? payout.payout_usd * 100 : null,
          payout.payout_scheme || null,
          payout.ga !== undefined && payout.ga !== null && payout.ga !== '' ? payout.ga : null,
          payout.id,
          userId
        ]);
      } else if (payout.pub_id && payout.id_product) {
        // Insert new record
        const insertQuery = `
          INSERT INTO payout_by_pub_id 
            (id_user, id_product, payout_usd, payout_scheme, pub_id, ga)
          VALUES 
            (?, ?, ?, ?, ?, ?)
        `;
        
        await dbExecuteDB2_Write(insertQuery, [
          userId,
          payout.id_product,
          payout.payout_usd ? payout.payout_usd * 100 : null,
          payout.payout_scheme || 'CPA',
          payout.pub_id,
          payout.ga !== undefined && payout.ga !== null && payout.ga !== '' ? payout.ga : null
        ]);
      }
    }

    return true;
  } catch (error) {
    console.error('Error saving publishID payout:', error);
    throw new Error('Error saving publishID payout: ' + error.message);
  }
};

// PUBLISHID SPECIFIC PAYOUT PLANS
export const savePublishIdPayoutPlan = async (userId, payoutPlanData, startDateTime) => {
  try {
    // Filter valid plans
    const validPlans = payoutPlanData.filter(plan => 
      plan && 
      plan.id_product && 
      plan.pub_id &&
      plan.payout_usd !== undefined && 
      plan.payout_usd !== null && 
      plan.payout_usd !== '' && 
      plan.payout_scheme
    );

    if (validPlans.length === 0) {
      throw new Error('No valid PublishID plans to save');
    }

    // Insert new plans into plan_payout_by_pub_id table
    const insertQuery = `
      INSERT INTO plan_payout_by_pub_id 
        (id_user, id_product, payout_usd, payout_scheme, pub_id, ga, start_from) 
      VALUES 
        (?, ?, ?, ?, ?, ?, ?)
    `;

    for (const plan of validPlans) {
      await dbExecuteDB2_Write(insertQuery, [
        userId,
        plan.id_product,
        plan.payout_usd * 100,
        plan.payout_scheme,
        plan.pub_id,
        plan.ga !== null && plan.ga !== undefined ? plan.ga : 0,
        startDateTime
      ]);
    }

    return true;
  } catch (error) {
    console.error('Error saving PublishID payout plan:', error);
    throw new Error('Error saving PublishID payout plan: ' + error.message);
  }
};

export const getPublishIdPayoutPlans = async (userId) => {
  try {
    const query = `
      SELECT 
        ppbp.id,
        ppbp.id_product,
        ppbp.payout_usd/100 as payout_usd,
        ppbp.payout_scheme,
        ppbp.pub_id,
        ppbp.ga,
        DATE_FORMAT(CONVERT_TZ(ppbp.start_from, @@session.time_zone, '+00:00'), '%Y-%m-%d %H:%i:%s') as start_from,
        ppbp.end_at,
        p.name as product_name
      FROM plan_payout_by_pub_id ppbp
      JOIN products p ON p.id = ppbp.id_product
      WHERE ppbp.id_user = ?
      AND (ppbp.end_at IS NULL OR ppbp.end_at > NOW())
      ORDER BY ppbp.start_from ASC, p.name ASC, ppbp.pub_id ASC
    `;
    const [plans] = await dbExecuteDB2_Write(query, [userId]);
    return plans;
  } catch (error) {
    console.error('Error fetching PublishID payout plans:', error);
    throw new Error('Error fetching PublishID payout plans: ' + error.message);
  }
};

// Cron function to process PublishID payout plans (for external server)
export const processPublishIdPayoutPlans = async () => {
  try {
    // Get all PublishID plans that should be activated
    const getPlansQuery = `
      SELECT 
        p.id,
        p.id_user,
        p.id_product,
        p.payout_usd,
        p.payout_scheme,
        p.pub_id,
        p.ga,
        p.start_from
      FROM plan_payout_by_pub_id p
      WHERE 
        p.start_from <= NOW()
        AND p.end_at IS NULL
        AND NOT EXISTS (
          SELECT 1 
          FROM payout_by_pub_id pbp 
          WHERE pbp.id_user = p.id_user 
          AND pbp.id_product = p.id_product 
          AND pbp.pub_id = p.pub_id
          AND pbp.updated_at >= p.start_from
        )
    `;

    const [plansToProcess] = await dbExecuteDB2_Write(getPlansQuery);

    // Process each plan
    const processPromises = plansToProcess.map(async (plan) => {
      // Update or insert into payout_by_pub_id
      const upsertQuery = `
        INSERT INTO payout_by_pub_id 
        (id_user, id_product, payout_usd, payout_scheme, pub_id, ga, updated_at)
        VALUES (?, ?, ?, ?, ?, ?, ?)
        ON DUPLICATE KEY UPDATE
        payout_usd = VALUES(payout_usd),
        payout_scheme = VALUES(payout_scheme),
        ga = VALUES(ga),
        updated_at = VALUES(updated_at)
      `;

      await dbExecuteDB2_Write(upsertQuery, [
        plan.id_user,
        plan.id_product,
        plan.payout_usd,
        plan.payout_scheme,
        plan.pub_id,
        plan.ga,
        plan.start_from
      ]);

      // Mark the plan as processed
      const updatePlanQuery = `
        UPDATE plan_payout_by_pub_id 
        SET end_at = NOW() 
        WHERE id = ?
      `;
      return dbExecuteDB2_Write(updatePlanQuery, [plan.id]);
    });

    await Promise.all(processPromises);

    return {
      success: true,
      processed: plansToProcess.length,
      message: `Processed ${plansToProcess.length} PublishID payout plans`
    };
  } catch (error) {
    console.error('Error processing PublishID payout plans:', error);
    throw new Error('Error processing PublishID payout plans: ' + error.message);
  }
};

// Historical leads data fetching
export const getHistoricalLeads = async (userId, productId, dateFrom, dateTo, publishId = null) => {
  try {
    let query = `
      SELECT id, id_user, id_product, payout_scheme, payout_usd/100 as payout_usd, publishID, clickID, STATUS,
      created_at,
      DATE_FORMAT(CONVERT_TZ(created_at, '+00:00', '+07:00'), '%Y-%m-%d %H:%i:%s') as created_at_jakarta
      FROM leads 
      WHERE id_user = ? AND id_product = ? 
      AND created_at >= ? AND created_at <= ?
    `;
    
    const params = [userId, productId, dateFrom, dateTo];

    if (publishId) {
      query += ` AND publishID = ?`;
      params.push(publishId);
    }

    query += ` ORDER BY created_at DESC LIMIT 500`;

    const [leads] = await dbExecuteDB2_ReadOnly(query, params);
    return leads;
  } catch (error) {
    console.error('Error fetching historical leads:', error);
    throw new Error('Error fetching historical leads: ' + error.message);
  }
};

// Update historical payout values with approved_at logic
export const updateHistoricalLeads = async (leadIds, newPayoutUsd, newPayoutScheme, leadsData) => {
  try {
    // Convert payout to cents for storage
    const payoutInCents = parseFloat(newPayoutUsd.toString().replace(',', '.')) * 100;
    
    if (isNaN(payoutInCents)) {
      throw new Error('Invalid payout value');
    }

    // Get current lead data to determine approved_at logic
    // Filter leadsData to only selected leads
    const selectedLeadsData = leadsData.filter(lead => leadIds.includes(lead.id));
    
    let updatedCount = 0;
    
    // Update each lead individually to handle approved_at logic
    for (const leadData of selectedLeadsData) {
      const oldScheme = leadData.payout_scheme;
      const leadStatus = leadData.STATUS;
      
      let approvedAtValue = undefined; // undefined means no change
      
      // Determine approved_at logic based on scheme change
      if (oldScheme === 'CPA' && newPayoutScheme === 'CPL') {
        // FROM CPA TO CPL: set approved_at = created_at if status NOT 'Double' and NOT 'Trash'
        if (leadStatus !== 'Double' && leadStatus !== 'Trash') {
          approvedAtValue = leadData.created_at;
        } else {
          approvedAtValue = null; // Set to NULL for Double/Trash
        }
      } else if (oldScheme === 'CPL' && newPayoutScheme === 'CPA') {
        // FROM CPL TO CPA: set approved_at = created_at ONLY for status='Sold' if approved_at is NULL
        if (leadStatus === 'Sold' && !leadData.approved_at) {
          approvedAtValue = leadData.created_at;
        }
        // For other cases when going from CPL to CPA, keep existing approved_at (no change)
      }
      // For same scheme (CPA->CPA or CPL->CPL), don't update approved_at
      
      // Build query based on whether we're updating approved_at
      let query;
      let params;
      
      if (approvedAtValue !== undefined) {
        // Update payout, scheme, and approved_at
        query = `
          UPDATE leads 
          SET payout_usd = ?, payout_scheme = ?, approved_at = ?
          WHERE id = ?
        `;
        params = [payoutInCents, newPayoutScheme, approvedAtValue, leadData.id];
      } else {
        // Update only payout and scheme
        query = `
          UPDATE leads 
          SET payout_usd = ?, payout_scheme = ?
          WHERE id = ?
        `;
        params = [payoutInCents, newPayoutScheme, leadData.id];
      }
      
      await dbExecuteDB2_Write(query, params);
      updatedCount++;
    }
    
    return { 
      success: true, 
      message: `Successfully updated ${updatedCount} leads with payout: $${(payoutInCents/100).toFixed(2)}, scheme: ${newPayoutScheme}`
    };
  } catch (error) {
    console.error('Error updating historical leads:', error);
    throw new Error('Error updating historical leads: ' + error.message);
  }
};

// Function to resend confirmation email
export const resendConfirmationEmail = async (email) => {
  try {
    // Check if user exists and needs confirmation
    const user = await getUserByEmail(email);
    if (!user) {
      return { 
        success: false, 
        message: 'Email address not found. Please check your email or register again.' 
      };
    }

    if (user.email_confirmed) {
      return { 
        success: false, 
        message: 'Your email is already confirmed. You can try logging in.' 
      };
    }

    if (user.is_accepted) {
      return { 
        success: false, 
        message: 'Your account is already active. You can try logging in.' 
      };
    }

    // Prefer description host (set at register) for branded confirm links
    const descHost = String(user.description || '')
      .split(':')[0]
      .toLowerCase();
    const result = await sendConfirmationEmail({
      email: user.email,
      confirm_token: user.confirm_token,
      linkHost: isLeadScaleMailHost(descHost) ? descHost : undefined,
    });

    return { 
      success: true, 
      message: 'Confirmation email has been resent. Please check your inbox and spam folder.' 
    };
  } catch (error) {
    console.error('Error resending confirmation email:', error);
    return { 
      success: false, 
      message: 'Failed to resend confirmation email. Please try again later.' 
    };
  }
};